<div fxLayout="row" fxLayoutAlign="center center">
  <!-- Estado 1 - Notificação não enviada -->
  <mat-icon *ngIf="!isNotificado && !isNotificacaoVisualizada" matTooltip="Não notificado" color="warn">
    notifications_off
  </mat-icon>

  <!-- Estado 2 - Notificação enviada, mas não visualizada -->
  <mat-icon
    *ngIf="isNotificado && notificadoAt && !isNotificacaoVisualizada"
    matTooltip="Notificado em: {{ notificadoAt | date : 'short' }}">
    notifications_active
  </mat-icon>

  <!-- Estado 3 - A notificação foi enviada e visualizada. -->
  <mat-icon
    *ngIf="isNotificacaoVisualizada && notificacaoVisualizadaAt"
    matTooltip="Notificação visualizada em: {{ notificacaoVisualizadaAt | date : 'short' }}"
    color="primary"
    >visibility</mat-icon
  >
</div>
